import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Paper
} from '@mui/material';

const RELEASE_TYPES = [
  { value: 'single', label: 'Single', minTracks: 1, maxTracks: 1 },
  { value: 'ep', label: 'EP', minTracks: 2, maxTracks: 6 },
  { value: 'album', label: 'Album', minTracks: 7, maxTracks: 20 }
];

const GENRE_OPTIONS = [
  'House', 'Deep House', 'Tech House', 'Techno', 'Trance', 'Minimal', 'Progressive House',
  'Disco', 'Nu Disco', 'Indie Dance', 'Electronica', 'Ambient', 'Downtempo',
  'Breaks', 'Drum & Bass', 'Dubstep', 'Trap', 'Hip Hop', 'R&B',
  'Pop', 'Rock', 'Indie', 'Alternative', 'Metal', 'Punk',
  'Jazz', 'Blues', 'Soul', 'Funk', 'Reggae', 'Dancehall',
  'Afrobeat', 'Latin', 'Classical'
];

const BasicReleaseInfo = ({ releaseData, setReleaseData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReleaseData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Release Information
      </Typography>
      <Grid container spacing={3}>
        {/* Release Title */}
        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            label="Release Title"
            name="title"
            value={releaseData.title}
            onChange={handleChange}
            helperText="Enter the complete title of your release"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: '#666666' },
                '&:hover fieldset': { borderColor: '#666666' },
                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
              }
            }}
          />
        </Grid>

        {/* Label */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Label"
            name="label"
            value={releaseData.label || ''}
            onChange={handleChange}
            helperText="The record label releasing this content"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: '#666666' },
                '&:hover fieldset': { borderColor: '#666666' },
                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
              }
            }}
          />
        </Grid>

        {/* Release Type */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth required sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#666666' },
              '&:hover fieldset': { borderColor: '#666666' },
              '&.Mui-focused fieldset': { borderColor: '#a187f2' }
            }
          }}>
            <InputLabel>Release Type</InputLabel>
            <Select
              name="type"
              value={releaseData.type}
              onChange={handleChange}
              label="Release Type"
            >
              {RELEASE_TYPES.map(type => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label} ({type.minTracks}-{type.maxTracks} tracks)
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Primary Genre */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth required sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#666666' },
              '&:hover fieldset': { borderColor: '#666666' },
              '&.Mui-focused fieldset': { borderColor: '#a187f2' }
            }
          }}>
            <InputLabel>Primary Genre</InputLabel>
            <Select
              name="primaryGenre"
              value={releaseData.primaryGenre}
              onChange={handleChange}
              label="Primary Genre"
            >
              {GENRE_OPTIONS.map(genre => (
                <MenuItem key={genre} value={genre}>
                  {genre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Secondary Genre */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#666666' },
              '&:hover fieldset': { borderColor: '#666666' },
              '&.Mui-focused fieldset': { borderColor: '#a187f2' }
            }
          }}>
            <InputLabel>Secondary Genre</InputLabel>
            <Select
              multiple
              name="secondaryGenres"
              value={releaseData.secondaryGenres}
              onChange={handleChange}
              label="Secondary Genre"
            >
              {GENRE_OPTIONS.filter(genre => genre !== releaseData.primaryGenre).map(genre => (
                <MenuItem key={genre} value={genre}>
                  {genre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BasicReleaseInfo;